<template>
  <div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('memberManagement.is_library') }}:</span>
        <el-radio-group size="medium" v-model="filter.is_library">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ yse_or_no(0) }}</el-radio>
          <el-radio :label="1">{{ yse_or_no(1) }}</el-radio>
        </el-radio-group>
      </el-row>
      <!-- <el-row class="mt20" type="flex" :gutter="20" align="middle">
          <span class="text">{{$t('memberManagement.is_publish')}}:</span>
          <el-radio-group size="medium" v-model="filter.is_publish">
               <el-radio label>{{$t('all')}}</el-radio>
              <el-radio :label="0">{{yse_or_no(0)}}</el-radio>
              <el-radio :label="1">{{yse_or_no(1)}}</el-radio>
          </el-radio-group>
      </el-row> -->
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset(['active'])" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t('btnTip.add')
        }}</el-button>
        <div>
          <el-button type="primary" @click="outExe">{{
            $t('outExe')
          }}</el-button>
          <el-button type="primary" @click="outExeAll('memberList')"
            >전체출력</el-button
          >
        </div>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:gender="slotProps">
          <div>
            {{ gender(slotProps.callback.row.gender) }}
          </div>
        </template>
        <template v-slot:address="slotProps">
          <div>
            {{ slotProps.callback.row.address }}
            {{ slotProps.callback.row.address_detail }}
          </div>
        </template>
        <template v-slot:delivery_request="slotProps">
          <div>
            {{ slotProps.callback.row.delivery_request }}
          </div>
        </template>
        <template v-slot:project="slotProps">
          <div>
            {{ project(slotProps.callback.row.project) }}
          </div>
        </template>
        <template v-slot:favorite_category="slotProps">
          <div>
            <span
              class="span"
              v-for="(item, index) in slotProps.callback.row.favorite_category"
              :key="index"
              ><span v-if="index !== 0">/</span
              >{{ favorite_category(item) }}</span
            >
          </div>
        </template>
        <template v-slot:is_library="slotProps">
          <div>
            {{ yse_or_no(slotProps.callback.row.is_library) }}
          </div>
        </template>
        <template v-slot:is_publish="slotProps">
          <div>
            {{ yse_or_no(slotProps.callback.row.is_publish) }}
          </div>
        </template>
        <template v-slot:is_policy="slotProps">
          <div>
            {{ yse_or_no(slotProps.callback.row.is_policy) }}
          </div>
        </template>
        <template v-slot:is_email="slotProps">
          <div>
            {{ yse_or_no(slotProps.callback.row.is_email) }}
          </div>
        </template>
        <template v-slot:is_sms="slotProps">
          <div>
            {{ yse_or_no(slotProps.callback.row.is_sms) }}
          </div>
        </template>
        <template v-slot:withdraw_date="slotProps">
          <div>
            {{ slotProps.callback.row.withdraw_date || '-' }}
          </div>
        </template>
        <template v-slot:login_time="slotProps">
          <div>
            {{ slotProps.callback.row.login_time || '-' }}
          </div>
        </template>
        <template v-slot:active="slotProps">
          <div>
            <el-tag
              :type="
                slotProps.callback.row.disable === 1
                  ? 'default'
                  : activeTag(slotProps.callback.row.active)
              "
              >{{
                slotProps.callback.row.disable === 1
                  ? '탈퇴'
                  : active(slotProps.callback.row.active)
              }}</el-tag
            >
          </div>
        </template>
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').check"
            placement="top"
          >
            <el-button
              @click="handleClick('check', slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            v-if="slotProps.callback.row.disable !== 1"
            class="item"
            effect="dark"
            :content="
              slotProps.callback.row.active === 0
                ? $t('accountManagement').active1
                : $t('accountManagement').active0
            "
            placement="top"
          >
            <el-button
              @click="handleClick('active', slotProps.callback.row)"
              :type="
                slotProps.callback.row.active === 0 ? 'success' : 'warning'
              "
              size="mini"
              >{{
                slotProps.callback.row.active === 0
                  ? $t('accountManagement').active1
                  : $t('accountManagement').active0
              }}</el-button
            >
          </el-tooltip>
          <el-dropdown class="ml10 mr10">
            <el-button type="primary" size="mini">
              {{ $t('memberManagement.more')
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                @click.native="
                  $router.push(
                    `/memberManagement/${slotProps.callback.row.id}/attendance`
                  )
                "
                >{{ $t('tMemberAttendance') }}</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="
                  $router.push(
                    `/memberManagement/${slotProps.callback.row.id}/comment`
                  )
                "
                >{{ $t('tMemberComment') }}</el-dropdown-item
              >
              <el-dropdown-item
                @click.native="
                  $router.push(
                    `/memberManagement/${slotProps.callback.row.id}/discuss`
                  )
                "
                >{{ $t('tMemberDiscuss') }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
            <el-tooltip 
              v-if="slotProps.callback.row.disable === 1"
              class="item"
              effect="dark"
              :content="$t('accountManagement').delete"
              placement="top"
            >
              <el-button
                @click="handleClick('delete', slotProps.callback.row)"
                type="danger"
                size="mini"
                >{{ $t('accountManagement').delete }}</el-button
              >
            </el-tooltip>
          <el-tooltip
            v-if="slotProps.callback.row.disable === 0"
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('infoEdit', slotProps.callback.row)"
              type="info"
              size="mini"
              >{{ $t('memberManagement').info_edit }}</el-button
            >
          </el-tooltip>
          <el-tooltip
            v-if="slotProps.callback.row.disable === 0"
            class="item"
            effect="dark"
            :content="$t('btnTip').resetPW"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              type="info"
              size="mini"
              >{{ $t('btnTip').resetPW }}</el-button
            >
          </el-tooltip>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="이메일 수정"
            placement="top"
          >
            <el-button
              @click="handleClick('change', slotProps.callback.row)"
              type="warning"
              size="mini"
              >이메일 수정</el-button
            >
          </el-tooltip> -->
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px">
      <form-page
        :ref-obj.sync="formInfo.ref"
        :data="formInfo.data"
        :field-list="formInfo.fieldList"
        :rules="formInfo.rules"
        :label-width="formInfo.labelWidth"
        :list-type-info="listTypeInfo"
        :disabled="formInfo.disabled"
      ></form-page>
      <span slot="footer" class="dialog-footer">
        <el-button @click="done('managerForm')" type="primary" class="ml30">{{
          buttonText
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import myTable from '@/components/table';
import FormPage from '@/components/FormPage';
import {
  memberList,
  memberChange,
  changeMemberUsername,
  addMember,
  editMember,
  delMember
} from '@/api/api';
const formInfoData = {
  password: '',
};
export default {
  name: 'memberManagement',
  mixins: [mixin_list(memberList)],
  components: {
    myTable,
    FormPage,
    page,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!rule.required) {
        callback();
        return;
      }
      const reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/;
      if (value === '') {
        callback(new Error(this.$t('memberManagement').passwordRule));
      } else {
        if (!reg.test(value)) {
          callback(new Error(this.$t('memberManagement').passwordRule));
        } else if (this.formInfo.data.password !== '') {
          callback();
        }
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (!rule.required) {
        callback();
        return;
      }
      const reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
      if (value === '') {
        callback(new Error('정확한 이메일 주소를 입력해 주세요.'));
      } else {
        if (!reg.test(value)) {
          callback(new Error('정확한 이메일 주소를 입력해 주세요.'));
        } else if (this.formInfo.data.password !== '') {
          callback();
        }
      }
    };
    return {
      filter: {
        search: '',
        is_library: '',
        is_publish: '',
      },
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('memberManagement.create_time'),
          sortable: true,
          prop: 'create_time',
        },
        {
          label: this.$t('memberManagement.username'),
          sortable: true,
          prop: 'username',
        },
        {
          label: this.$t('memberManagement.real_name'),
          sortable: true,
          prop: 'real_name',
        },
        {
          label: this.$t('memberManagement.gender'),
          sortable: true,
          slot: 'gender',
          prop: 'gender',
          width: 80,
        },
        {
          label: this.$t('memberManagement.birth'),
          sortable: true,
          prop: 'birth',
        },
        {
          label: this.$t('memberManagement.phone'),
          sortable: true,
          prop: 'phone',
        },
        {
          label: this.$t('memberManagement.address'),
          sortable: true,
          prop: 'address',
          slot: 'address',
        },
        {
          label: this.$t('memberManagement.delivery_request'),
          sortable: true,
          prop: 'delivery_request',
          slot: 'delivery_request',
        },
        {
          label: this.$t('memberManagement.project'),
          slot: 'project',
          sortable: true,
          prop: 'project',
        },
        {
          label: this.$t('memberManagement.favorite_category'),
          slot: 'favorite_category',
          prop: 'favorite_category',
        },
        {
          label: this.$t('memberManagement.is_library'),
          sortable: true,
          slot: 'is_library',
          prop: 'is_library',
        },
        // {
        //   label: this.$t("memberManagement.is_publish"),
        //   sortable: true,
        //   slot: "is_publish",
        //   prop: "is_publish",
        // },
        {
          label: this.$t('memberManagement.is_policy'),
          sortable: true,
          slot: 'is_policy',
          prop: 'is_policy',
          width: 150,
        },
        {
          label: this.$t('memberManagement.is_email'),
          sortable: true,
          slot: 'is_email',
          prop: 'is_email',
          width: 150,
        },
        {
          label: this.$t('memberManagement.is_sms'),
          sortable: true,
          slot: 'is_sms',
          prop: 'is_sms',
        },
        {
          label: this.$t('memberManagement.login_time'),
          sortable: true,
          slot: 'login_time',
          prop: 'login_time',
        },
        {
          label: this.$t("memberManagement.withdraw_date"),
          sortable: true,
          slot: "withdraw_date",
          prop: "withdraw_date",
        },
        {
          label: this.$t('memberManagement.active'),
          sortable: true,
          slot: 'active',
          prop: 'active',
        },
        {
          label: this.$t('operation'),
          prop: '',
          width: 450,
          slot: 'operation',
          fixed: 'right',
          headerAlign: 'center',
          align: 'left',
        },
      ],
      formInfo: {
        ref: null,
        disabled: false,
        data: formInfoData,
        fieldList: [
          {
            label: this.$t('memberManagement').username,
            value: 'username',
            type: 'input',
            width: '260',
            className: 'el-form-block',
            required: true,
            hidden: false,
            validator: validatePass1,
          },
          {
            label: this.$t('memberManagement').real_name,
            value: 'real_name',
            type: 'input',
            width: '260',
            className: 'el-form-block',
            required: true,
            hidden: false,
          },
          {
            label: this.$t('memberManagement').password,
            value: 'password',
            type: 'input',
            width: '260',
            className: 'el-form-block',
            // required: true,
            hidden: false,
            message: this.$t('memberManagement').passwordRule,
            validator: validatePass,
          },
        ],
        rules: {},
        labelWidth: '120px',
      },
      listTypeInfo: {},
      dialogFormVisible: false,
      which: '',
    };
  },
  computed: {
    title() {
      switch (this.which) {
        case 'add':
          return this.$t('btnTip').add;
        case 'edit':
          return this.$t('btnTip').edit;
        case 'change':
          return this.$t('btnTip').edit;
      }
    },
    buttonText() {
      switch (this.which) {
        case 'add':
          return this.$t('btnTip').submit;
        case 'edit':
          return this.$t('btnTip').submit;
        case 'change':
          return this.$t('btnTip').submit;
      }
    },
  },
  methods: {
    favorite_category(favorite_category) {
      switch (favorite_category) {
        case 0:
          return this.$t('memberManagement').favorite_category0;
        case 1:
          return this.$t('memberManagement').favorite_category1;
        case 2:
          return this.$t('memberManagement').favorite_category2;
        case 3:
          return this.$t('memberManagement').favorite_category3;
        case 4:
          return this.$t('memberManagement').favorite_category4;
        case 5:
          return this.$t('memberManagement').favorite_category5;
        case 6:
          return this.$t('memberManagement').favorite_category6;
        case 7:
          return this.$t('memberManagement').favorite_category7;
        case 8:
          return this.$t('memberManagement').favorite_category8;
        case 9:
          return this.$t('memberManagement').favorite_category9;
      }
    },
    active(active) {
      switch (active) {
        case 0:
          return this.$t('accountManagement').active0;
        case 1:
          return this.$t('accountManagement').active1;
      }
    },
    activeTag(active) {
      switch (active) {
        case 0:
          return 'danger';
        case 1:
          return 'success';
      }
    },
    yse_or_no(yse_or_no) {
      switch (yse_or_no) {
        case 0:
          return this.$t('memberManagement').no;
        case 1:
          return this.$t('memberManagement').yes;
      }
    },
    gender(gender) {
      switch (gender) {
        case 0:
          return this.$t('memberManagement').gender0;
        case 1:
          return this.$t('memberManagement').gender1;
        case 2:
          return this.$t('memberManagement').gender2;
        case 3:
          return this.$t('memberManagement').gender3;
      }
    },
    project(project) {
      let str = '';
      let arr = project.split(',');
      arr.forEach((item, index) => {
        switch (item) {
          case '0':
            str += this.$t('memberManagement').project0;
            break;
          case '1':
            str += this.$t('memberManagement').project1;
            break;
          case '2':
            str += this.$t('memberManagement').project2;
            break;
          case '3':
            str += this.$t('memberManagement').project3;
            break;
        }
        if (index !== arr.length - 1) {
          str += '/';
        }
      });
      return str;
    },
    async handleClick(type, data) {
      switch (type) {
        case 'add':
          this.formInfo.data = {
            username: '',
            real_name: '',
            password: '',
          };
          this.formInfo.fieldList[0].required = true;
          this.formInfo.fieldList[0].hidden = false;
          this.formInfo.fieldList[1].required = true;
          this.formInfo.fieldList[1].hidden = false;
          this.formInfo.fieldList[2].required = true;
          this.formInfo.fieldList[2].hidden = false;
          this.initRules();
          this.formInfo.disabled = type !== 'check' ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case 'check':
          this.$router.push(`/memberManagement/detail?id=${data.id}`);
          break;
        case 'active':
          if (data.active === 0) {
            await memberChange({
            id: data.id,
              active: data.active === 0 ? 1 : 0,
            });
            this.get_list();
          } else {
            this.$confirm(this.$t("accountManagement").sureDeActive, this.$t("btnTip").active, {
              confirmButtonText: this.$t("btnTip").active,
              cancelButtonText: this.$t("btnTip").cancel,
              type: "warning",
            }).then(async () => {
            await memberChange({
              id: data.id,
                active: data.active === 0 ? 1 : 0,
              });
              this.get_list();
            });
          }
          break;
        case 'infoEdit':
          this.$router.push(`/memberManagement/edit?id=${data.id}`);
          break;
        case 'edit':
          this.formInfo.data = {
            id: data.id,
            password: '',
          };
          this.formInfo.fieldList[0].required = false;
          this.formInfo.fieldList[0].hidden = true;
          this.formInfo.fieldList[1].required = false;
          this.formInfo.fieldList[1].hidden = true;
          this.formInfo.fieldList[2].required = true;
          this.formInfo.fieldList[2].hidden = false;
          this.initRules();
          this.formInfo.disabled = type !== 'check' ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case 'change':
          this.formInfo.data = {
            id: data.id,
            username: data.username,
          };
          this.formInfo.fieldList[0].required = true;
          this.formInfo.fieldList[0].hidden = false;
          this.formInfo.fieldList[1].required = false;
          this.formInfo.fieldList[1].hidden = true;
          this.formInfo.fieldList[2].required = false;
          this.formInfo.fieldList[2].hidden = true;
          this.initRules();
          this.formInfo.disabled = type !== 'check' ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case "delete":
          this.$confirm(this.$t("accountManagement").sureDeleteAccount, this.$t("btnTip").delete, {
            confirmButtonText: this.$t("btnTip").delete,
            cancelButtonText: this.$t("btnTip").cancel,
            type: "warning",
          }).then(async () => {
            await delMember(data.id);
            this.get_list();
          });
          break;
      }
    },
    done() {
      switch (this.which) {
        case 'add':
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              this.dialogFormVisible = false;
              await addMember(this.formInfo.data);
              this.get_list();
            }
          });
          break;
        case 'edit':
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              this.dialogFormVisible = false;
              await memberChange(this.formInfo.data);
              this.get_list();
            }
          });
          break;
        case 'change':
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              this.dialogFormVisible = false;
              await changeMemberUsername(this.formInfo.data);
              this.get_list();
            }
          });
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  width: 150px;
  font-size: 16px;
}
/deep/ label {
  margin-bottom: 0 !important;
}

.el-tag--default {
  border-radius: 5px;
  border: 1px solid #E9E9EB;

  background: #F4F4F5;
  color: #919399;
}
</style>
